import React from "react";

function CollaborationIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="57"
            height="57"
            fill="none"
            viewBox="0 0 57 57"
        >
            <rect width="57" height="57" fill="#EF4F80" rx="10"></rect>
            <path
                fill="#fff"
                d="M35.002 29.6a6.401 6.401 0 00-6.4 6.4v7.357c0 .353.283.643.642.643H40.76a.641.641 0 00.643-.643V36c0-3.534-2.867-6.4-6.4-6.4zM35.003 26.4a4.8 4.8 0 100-9.6 4.8 4.8 0 000 9.6zM22.2 24.8a6.401 6.401 0 00-6.4 6.4v7.357c0 .353.284.643.643.643h8.315a.641.641 0 00.643-.643V36a9.56 9.56 0 012.564-6.52.629.629 0 00.138-.668c-.945-2.35-3.219-4.012-5.902-4.012zM22.202 21.6a4.8 4.8 0 100-9.6 4.8 4.8 0 000 9.6z"
            ></path>
        </svg>
    );
}

export default CollaborationIcon;
